import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export var useInfoDialogStore = create()(devtools(function (set) { return ({
    show: false,
    content: undefined,
    setShow: function (show) { return set(function () { return ({ show: show }); }); },
    setContent: function (content) { return set(function () { return ({ content: content }); }); },
}); }));
